angular
    .module('WizApp')
    .service('SettingsService', [
        '$http',
        '$filter',
        function ($http, $filter) {
            var route = $filter('route');

            return {
                update: function (data) {
                    var url = route('wizbii_profileui_configuration_update');

                    return $http.post(url, data);
                }
            };
        }
    ])
;
